import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { DataObjectGroupUrl } from './DataObjectGroupUrl';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { DataObjectGroupDto } from '../schema/types';
import { DataObjectGroupSchema } from '../schema/DataObjectGroupSchema';

const getDataObjectGroup = ({ id }: { id: number }) => {
  return apiClient
    .get<DataObjectGroupDto>(expand(DataObjectGroupUrl.GROUP, { id }))
    .then((response) => DataObjectGroupSchema.parse(response.data));
};

export const useDataObjectGroupQuery = createApiQueryHook(
  ['data-object-group'],
  getDataObjectGroup
);
